import { render, staticRenderFns } from "./examDetail.vue?vue&type=template&id=949c3c80&scoped=true"
import script from "./examDetail.vue?vue&type=script&lang=js"
export * from "./examDetail.vue?vue&type=script&lang=js"
import style0 from "./examDetail.vue?vue&type=style&index=0&id=949c3c80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949c3c80",
  null
  
)

export default component.exports